// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ir58ld {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--spacing-2);
  width: 100%;
}

.cSn5DD {
  display: grid;
  width: 100%;
  align-items: center;
}

.Bxr36D {
  grid-area: 1 / 1;
  width: 100%;
  align-self: center;
  visibility: hidden;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.3s ease;
}

.r7rF3w {
  visibility: visible;
  opacity: 1;
  pointer-events: auto;
}

.sBlrM7 {
  display: flex;
  gap: 6px;
}

.yIT5Q8 {
  width: 6px;
  height: 6px;
  border-radius: 999px;
  background: var(--surface-neutral-soft);
  border: none;
  padding: 0;
  cursor: pointer;
  transition:
    width 0.3s ease,
    background-color 0.3s ease;
}

.pJUppD {
  width: 16px;
  background: var(--surface-primary-medium);
}

.yIT5Q8:focus {
  outline: 2px solid var(--surface-primary-medium);
  outline-offset: 2px;
}
`, "",{"version":3,"sources":["webpack://./../../packages/shared-ui/src/components/CardCarousel/CardCarousel.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,uCAAuC;EACvC,YAAY;EACZ,UAAU;EACV,eAAe;EACf;;8BAE4B;AAC9B;;AAEA;EACE,WAAW;EACX,yCAAyC;AAC3C;;AAEA;EACE,gDAAgD;EAChD,mBAAmB;AACrB","sourcesContent":[".wrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: var(--spacing-2);\n  width: 100%;\n}\n\n.slideStack {\n  display: grid;\n  width: 100%;\n  align-items: center;\n}\n\n.slideItem {\n  grid-area: 1 / 1;\n  width: 100%;\n  align-self: center;\n  visibility: hidden;\n  opacity: 0;\n  pointer-events: none;\n  transition: opacity 0.3s ease;\n}\n\n.slideItemActive {\n  visibility: visible;\n  opacity: 1;\n  pointer-events: auto;\n}\n\n.dots {\n  display: flex;\n  gap: 6px;\n}\n\n.dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 999px;\n  background: var(--surface-neutral-soft);\n  border: none;\n  padding: 0;\n  cursor: pointer;\n  transition:\n    width 0.3s ease,\n    background-color 0.3s ease;\n}\n\n.dotActive {\n  width: 16px;\n  background: var(--surface-primary-medium);\n}\n\n.dot:focus {\n  outline: 2px solid var(--surface-primary-medium);\n  outline-offset: 2px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `ir58ld`,
	"slideStack": `cSn5DD`,
	"slideItem": `Bxr36D`,
	"slideItemActive": `r7rF3w`,
	"dots": `sBlrM7`,
	"dot": `yIT5Q8`,
	"dotActive": `pJUppD`
};
module.exports = ___CSS_LOADER_EXPORT___;
